import { Observable } from 'rxjs';
import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit } from '@angular/core';

import { FormGroup, FormBuilder, Validators, FormArray, FormControl } from '@angular/forms';
import { Router, NavigationEnd } from '@angular/router';
import Swal from "sweetalert2";
import { MatSnackBar } from '@angular/material/snack-bar';
import { Store } from '@ngrx/store';
import { PipelineLicenseCategoryDto } from '@cradua/data';

@Component({
  selector: 'cradua-pipeline-license-category',
  templateUrl: './pipeline-license-category.component.html',
  styleUrls: ['./pipeline-license-category.component.scss']
})
export class PipelineLicenseCategoryComponent implements OnInit {

  pipelinelicensecategoryForm: FormGroup;
  control = new FormControl();
  @Input() pipelinelicensecategorys: any[];
  @Input() routeAnimationsElements: any;
  @Output() pipelinelicensecategory = new EventEmitter<PipelineLicenseCategoryDto>()
  @Output() deletePipelineLicenseCategoryEvent = new EventEmitter<any>()
  
    selectedPipelineLicenseCategory: any;
    filteredDelete: Array<any> =[];
    loading = true;
    constructor(
     private fb: FormBuilder,
     private router: Router,
     private snackBar: MatSnackBar
     ) {}
  
    ngOnInit() {
       this.pipelinelicensecategoryForm = this.fb.group({PipelineLicenseCategorys: this.fb.array([])});
    }
  
    ngAfterViewInit() {
      setTimeout(() => {
        console.log("data: ", this.pipelinelicensecategorys);
  
          this.loading = false;
          this.setPipelineLicenseCategory();
      }, 500)
    }
  
  
  // method to display PipelineLicenseCategorys
  setPipelineLicenseCategory() {
    console.log("data...: ", this.pipelinelicensecategorys);
    const control  = this.pipelinelicensecategoryForm.controls.PipelineLicenseCategorys as FormArray;
    this.pipelinelicensecategorys.forEach( e => {
      control.push(
        this.fb.group({
          PipelineLicenseCategoryName: e.PipelineLicenseCategoryName,
          EstimatedDuration: e.EstimatedDuration,
          id: e.id[0]
        })
      );
    });
  }
  
  
  // method to add PipelineLicenseCategory
  addPipelineLicenseCategory() {
    const control  = this.pipelinelicensecategoryForm.controls.PipelineLicenseCategorys as FormArray;
    control.insert(0,
          this.fb.group({
            PipelineLicenseCategoryName: [''],
            EstimatedDuration: [''],
            id: null
          })
       );
  }
  
  
  // method to delete PipelineLicenseCategory from arrary list
  deletePipelineLicenseCategory(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
  const control = this.pipelinelicensecategoryForm.controls.PipelineLicenseCategorys as FormArray;
  control.removeAt(index);
  for ( let i = 0; i < this.pipelinelicensecategorys.length; i++) {
      if (i === index) {
        if (value.id !== null) {
          this.filteredDelete.push(this.pipelinelicensecategorys[i].id);
          console.log('delete: ', JSON.stringify(value));
         }
  
      }
    }
  Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error'
          );
        }
      });
  }
  
  onSubmit(formValue: any) {
  this.pipelinelicensecategory.emit(formValue);
  if(this.filteredDelete.length !== 0) {
    this.deletePipelineLicenseCategoryEvent.emit(this.filteredDelete);
  }
  }
  
  }
